import { type TableColumnFormat } from '@blaze-shared/elements-domain';
import { findColumn } from '@blaze-shared/schema-domain';
import { type BlazeSchema, type DatasetColumnFormat } from '@blaze-shared/schema-domain';

export function convertFormatToTableColumnFormat(
  value?: DatasetColumnFormat['formatType'],
): TableColumnFormat | undefined {
  switch (value) {
    case 'Currency':
      return 'currency';
    case 'Percent':
      return 'percentage';
    case 'SingleLine':
      return 'text';
    case 'Paragraph':
      return 'paragraph';
    case 'RichText':
      return 'richText';
    case 'Email':
      return 'email';
    case 'Url':
      return 'url';
    case 'PhoneNumber':
      return 'phoneNumber';
    case 'ZipCode':
      return 'zipcode';
    case 'TimeZone':
      return 'timezone';
    case 'Duration':
      return 'duration';
    case 'GeoPoint':
      return 'geopoint';
    case 'SecureText':
      return 'secureText';
  }
  return undefined;
}

export function isColumnPercentage(columnName: string, schema: BlazeSchema | undefined): boolean {
  return findColumn(schema?.columns, columnName)?.format?.formatType === 'Percent';
}
